// @ts-nocheck
import SplitText from "../components/splitText";
import { animate } from "../components/animeComponents";

export const loadAnimations = () => {
    new SplitText(".historical__title");
    new SplitText(".historical__carousel-title");
    loadAnimationsGalleryCoros();
    loadAnimationsBasicVideo();
    loadAnimationsSomosPresidenteProducts();
    animate();
    AOS.init({
      once: true,
    });
};

// core animations
const setDataAos = (
  element: HTMLElement,
  fade = "fade-up",
  delay = 0,
  duration = 1500
) => {
  element.setAttribute("data-aos", `${fade}`);
  element.setAttribute("data-aos-delay", `${delay}`);
  element.setAttribute("data-aos-duration", `${duration}`);
};

export const loadAnimationsGalleryCoros = () => {
  let delay = 0;
  const coros = document.querySelectorAll(".coros-gallery .views-row");
  if (!!coros) {
    coros.forEach((coro) => {
      setDataAos(coro, "fade-up", delay, 1200);
      delay += 200;
    });
  }
};

export const loadAnimationsBasicVideo = () => {
  let delay = 0;
  const videoContainer = document.querySelector(".basic_video");
  if (!!videoContainer) {
    const items = videoContainer.querySelector(".basic_video__content");
    const itemsArr = [...items.children];
    itemsArr.map((nodo) => {
      setDataAos(nodo, "fade-up", delay, 1500);
      delay += 200;
    });
  }
};
export const loadAnimationsSomosPresidenteProducts = () => {
  const productContainer = document.querySelector(".somos-presidente-products");
  if (!!productContainer) {
    let delay = 0;
    const slides = productContainer.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const items = slide.querySelector(".field-content");
      const itemsArr = [...items.children];
      itemsArr.map((nodo) => {
        setDataAos(nodo, "fade-up", delay, 1500);
      });
      delay += 200;
    });

    const title = productContainer.querySelector(
      ".somos-presidente-products--title"
    );
    // const footer = productContainer.querySelector(".somos-presidente-products--footer")

    setDataAos(title, "fade-up", 0, 1500);
    // setDataAos(footer, "fade-up", 0, 1500)
  }
};
